export default __webpack_public_path__ + "static/mainguy-17b3daa7992bc3c2845e0a46e65ce92db4c6006b8d383ed6c9add6e9150dd878.png";